import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import Order from "./pages/Order";
import Appointment from "./pages/Appointment";
import Customer from "./pages/Customer";
import Login from "./pages/Login";
import Brand from "./pages/Brand";
import Device from "./pages/Device";
import Replacement from "./pages/Replacement";
import Status from "./pages/Status";
import WorkType from "./pages/WorkType";
import {ToastContainer} from "react-toastify";
import ForgotPassword from "./pages/ForgotPassword";
import OrderView from "./pages/OrderView";
import CustomerView from "./pages/CustomerView";
import OrderTrack from "./pages/OrderTrack";
import PrivateRoute from "./components/PrivateRoute";
import NotFound from "./pages/NotFound";
import Services from "./pages/Services";

const router = createBrowserRouter([
    {path: "*", element: <NotFound/>},
    {path: "/", element: <App/>},
    {path: "/login", element: <Login/>},
    {path: "/resetPassword", element: <ForgotPassword/>},
    {
        path: "/order", element: (
            <PrivateRoute>
                <Order/>
            </PrivateRoute>
        )
    },
    {
        path: "/order/:orderId", element: (
            <PrivateRoute>
                <OrderView/>
            </PrivateRoute>
        )
    },
    {path: "/track/:orderId", element: <OrderTrack/>},
    {
        path: "/customer", element: (
            <PrivateRoute>
                <Customer/>
            </PrivateRoute>
        )
    },
    {
        path: "/customer/:customerId", element: (
            <PrivateRoute>
                <CustomerView/>
            </PrivateRoute>
        )
    },
    {
        path: "/appointment", element: (
            <PrivateRoute>
                <Appointment/>
            </PrivateRoute>
        )
    },
    {
        path: "/brand", element: (
            <PrivateRoute>
                <Brand/>
            </PrivateRoute>
        )
    },
    {
        path: "/device", element: (
            <PrivateRoute>
                <Device/>
            </PrivateRoute>
        )
    },
    {
        path: "/replacement", element: (
            <PrivateRoute>
                <Replacement/>
            </PrivateRoute>
        )
    },
    {
        path: "/status", element: (
            <PrivateRoute>
                <Status/>
            </PrivateRoute>
        )
    },
    {
        path: "/workType", element: (
            <PrivateRoute>
                <WorkType/>
            </PrivateRoute>
        )
    },
    {
        path: "/service", element: (
            <PrivateRoute>
                <Services/>
            </PrivateRoute>
        )
    },
]);
const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <RouterProvider router={router}/>
        <ToastContainer/>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
